<template>
  <div class="columns is-multiline mb-30" v-if="Recom">
    <div class="column is-6-desktop is-4-widescreen is-mobile" v-for="(panneau, index) in panneaux" :key="index">
      <div class="card is-relative is-height-100p">
        <div class="card-image pointer">
          <figure class="card-img-panneau">

            <img class="img-panneau" :src="getImg(panneau.srcImg)">

            <div class="bande-info" @click="affichePanneau(index)">
              <div class="level has-text-weight-bold is-mobile">
                <div class="level-left is-size-7">
                  {{`Du ${formatDate(afficheDetail(panneau).dateDebut)} au ${formatDate(afficheDetail(panneau).dateFin)}`}}
                </div>
                <div class="level-right is-size-18px">
                  {{formatNombre(afficheDetail(panneau).prixTotal)}}
                </div>
              </div>
            </div>

          </figure>

          <div  @click="controlSelect(panneau)" v-if="afficheSelect()"
              class="dot-external"
              :class="{'dot-external__select': panneau.select}">
              <div class="dot-internal" v-if="panneau.select"></div>
            </div>

        </div>

        <div class="card-content pa-20 mb-40 pointer" @click="affichePanneau(index)"
          :class="{
            'is-echeancier-fictif': panneau.isEcheanceFictive,
            'is-echeancier-non-renouvelee': panneau.isNonRenouvelee
          }">
          <div class="columns is-multiline mb-0 is-mobile">

            <div class="column is-12" v-if="panneau.adresseCommerciale">
              <div class="level is-mobile">
                <div class="level-left">
                  <div class="level-item">
                    <div class="num-panneau has-text-centered">
                      <span class="has-text-white is-size-14px">{{panneau.num}}</span>
                    </div>
                  </div>
                  <div class="level-item">
                    <div class="width-libelle">
                      <p class="has-text-default is-size-10px"> Adresse </p>
                      <p class="has-text-grid-1 has-text-weight-bold is-size-14px
                          mb-0 truncate-libelle">
                        {{panneau.adresseCommerciale}}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="column is-6" v-if="showFormat(panneau)">
              <div class="media">
                <b-icon
                  icon="vector-intersection"
                  size="is-medium"
                  class="media-left"
                  type="is-grid-5">
                </b-icon>
                <div class="media-content is-size-10px has-text-default">
                  <label class="has-text-default">
                    Format
                  </label>
                  <p class="is-size-14px has-text-weight-bold has-text-grid-1 mt-4">
                    {{panneau.format}}
                  </p>
                </div>
              </div>
            </div>

            <div class="column is-6" v-if="panneau.materiel">
              <div class="media">
                <b-icon
                  icon="package-variant-closed"
                  size="is-medium"
                  class="media-left"
                  type="is-grid-5">
                </b-icon>
                <div class="media-content is-size-10px has-text-default">
                  <label class="has-text-default">
                    Matériel
                  </label>
                  <p class="is-size-14px has-text-weight-bold has-text-grid-1 mt-4">
                    {{panneau.materiel}}
                  </p>
                </div>
              </div>
            </div>

            <div class="column is-6" v-if="panneau.categorie.libelle">
              <div class="media">
                <b-icon
                  icon="sign-text"
                  size="is-medium"
                  class="media-left"
                  type="is-grid-5">
                </b-icon>
                <div class="media-content is-size-10px has-text-default">
                  <label class="has-text-default">
                    Catégorie
                  </label>
                  <p class="is-size-14px has-text-weight-bold has-text-grid-1 mt-4">
                    {{panneau.categorie.libelle}}
                  </p>
                </div>
              </div>
            </div>

            <div class="column is-6" v-if="panneau.regie">
              <div class="media">
                <b-icon
                  icon="sign-text"
                  size="is-medium"
                  class="media-left"
                  type="is-grid-5">
                </b-icon>
                <div class="media-content is-size-10px has-text-default">
                  <label class="has-text-default">
                    Régie
                  </label>
                  <p class="is-size-14px has-text-weight-bold has-text-grid-1 mt-4">
                    {{panneau.regie}}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div class="mb-40" v-if="panneau.commentaire">
            <label class="has-text-default is-size-10px">Argumentaire</label>
            <p class="has-text-grid-1 is-size-14px pre-line-text">
              {{panneau.commentaire}}
            </p>
          </div>

        </div>

        <div class="card-footer card-footer__custum has-background-grid-5">
          <a class="card-footer-item pa-10" @click="affichePanneau(index)">
            <p class="is-size-14px has-text-white">
              Cliquer pour plus d’informations
            </p>
          </a>
        </div>

      </div>
    </div>
    <transition
      name="custom-classes-transition"
      enter-active-class="animated slideInRight"
      leave-active-class="animated slideOutRight"
      :duration="300"
      v-on:after-enter="bg = true"
      v-on:after-leave="bg = false">
      <detailPanneau :bg="bg" :detailPanneau="detailPanneau" :enseigne="enseigne" v-if="show"/>
    </transition>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { formatDate, getImg, formatNombre } from '@/services/general/general';
import DetailPanneau from './DetailPanneau';

const Recommandation = createNamespacedHelpers('recommandation');
const User = createNamespacedHelpers('user');
export default {
  components: {
    DetailPanneau,
  },
  data: () => ({
    budget: {},
    show: false,
    detailPanneau: {},
    bg: false,
  }),
  computed: {
    ...User.mapGetters({
      site: 'site',
    }),
    ...Recommandation.mapGetters({
      societe: 'societe',
    }),
    ...Recommandation.mapGetters({
      Recom: 'recom',
    }),
    panneaux() {
      return this.Recom.data.pointDeVentes[0].panneaux;
    },
    enseigne() {
      return this.Recom.data.pointDeVentes[0].enseigne;
    }
  },
  methods: {
    ...Recommandation.mapActions([
      'add',
      'substract',
      'addNbSelect',
      'substractNbSelect',
    ]),
    controlSelect(panneau) {
      panneau.select = !panneau.select;
      if (panneau.select) {
        this.add(this.afficheDetail(panneau).prixTotal);
        this.addNbSelect();
      } else {
        this.substract(this.afficheDetail(panneau).prixTotal);
        this.substractNbSelect();
      }
    },
    formatDate(date) {
      return formatDate(date);
    },
    getImg(img) {
      var afficheImageGenerique = false;
      // if (this.site === 'havas') afficheImageGenerique = true;
      if (this.societe?.nom === 'STEFFEN') afficheImageGenerique = true;
      return getImg(img,afficheImageGenerique );
    },
    formatNombre(val) {
      return formatNombre(val);
    },
    afficheDetail(panneau) {
      if (panneau.budgetProrata.prixNet || panneau.budgetProrata.tlpe
         || panneau.budgetProrata.fraisTechnique
         || panneau.budgetProrata.honorarires
         || panneau.budgetProrata.dateDebut
         || panneau.budgetProrata.dateFin) {
        return panneau.budgetProrata;
      }
      return panneau.budgetAnnuel;
    },
    affichePanneau(i) {
      this.detailPanneau = this.panneaux[i];
      this.show = true;
    },
    afficheSelect() {
      if (this.enseigne === 'GEANT CASINO') return false;
      if (this.enseigne === 'FRANPRIX') return false;
      if (this.enseigne === 'SUPERMACHE CASINO') return false;
      else return true;
    },
    showFormat(panneau) {
      return !!panneau.format && !['FORFAIT HONORAIRES', 'honoraire'].includes(panneau.categorie.libelle)
    }
  },
}
</script>

